"use client";

import Image from "@/components/ui/CardImage";
import React from "react";
import { getFocusPointStyle, ImageMetadata, BLUR_PLACEHOLDER } from '@/lib/componentutills';

type Props = {
  className?: string;
  imageMetadata?: ImageMetadata;
};

/*
  Pixel-perfect banner replicating public/dinamani/astro.png
  Uses:
   - Background: /dinamani/astology_back.png
   - Logo:       https://media.dinamani.com/dinamani/2026-02-27/oma80fx0/dinamanilogodarkmode.png
*/
export default function AstrologyNewsImageAdd({ className = "", imageMetadata }: Props) {
  return (
    <div
      className={`relative overflow-hidden ${className}`}
    >
      {/* Background image with deep blue overlay to match artwork */}
      <Image
        src="https://media.dinamani.com/dinamani/2026-02-27/mo3fzj4j/astroback.png"
        alt="Astrology background"
        fill
        loading="lazy"
        sizes="439px"
        className="object-cover"
        style={getFocusPointStyle(imageMetadata)}
        placeholder="blur"
        blurDataURL={BLUR_PLACEHOLDER}
      />
      <div className="absolute inset-0 bg-[radial-gradient(120%_120%_at_10%_10%,rgba(20,46,106,0.35)_0%,rgba(6,21,54,0.85)_0%,rgba(7,19,46,0.95)_100%)]" />

      {/* Right circular image accent (zodiac) like the reference */}
      <div className="absolute -right-16 -top-16 h-[260px] w-[260px] rounded-[50%] overflow-hidden border border-FFFFFF/10 z-10">
        <div className="relative w-full h-full">
          <Image
            src="https://media.dinamani.com/dinamani/2026-02-27/mo3fzj4j/astroback.png"
            alt="Zodiac wheel"
            fill
            sizes="260px"
            className="object-cover scale-[1.05]"
            style={getFocusPointStyle(imageMetadata)}
            loading="lazy"
            placeholder="blur"
            blurDataURL={BLUR_PLACEHOLDER}
          />
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10 h-full p-6 gap-4 flex flex-col">
        {/* Logo */}
        <Image
          src="https://media.dinamani.com/dinamani/2026-02-27/y9s7ztw3/dinamanilogo.png"
          alt="Dinamani"
          width={100}
          height={24}
          className="opacity-100"
          loading="lazy"
        />

        {/* Headline */}
        <div className="mt-5 space-y-1 leading-tight">
          <div className="text-16-tamil-900 text-FFFFFF leading-[1.5] clamp-3 mr-[25%]">தினமணி ஜோதிடம் வழங்கும் பிரத்தியேக சேவை!</div>
        </div>

        {/* Description bullets in a single wrapped row with separators */}
        <div className="mt-5 text-FFFFFF text-10-tamil-600 leading-[1.8] clamp-3">
          தொழில் | வேலைவாய்ப்பு | திருமணம் | முதல்கலை | குழந்தைப்பேறு வரை பலன்கள் | வெளிநாடு யோகா | கிரக பலன்கள்
        </div>

        {/* CTA */}
        <div className="mt-auto pt-6">
          <button
            type="button"
            className="group inline-flex items-center gap-2 text-FFDB59 text-16-english-800 tracking-[0.14em] uppercase"
          >
            Visit Now
            <svg
              className="h-5 w-5 text-FFDB59 transition-transform group-hover:translate-x-0.5"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden
            >
              <path d="M5 12h14" />
              <path d="M13 6l6 6-6 6" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}
